<template>
  <div class="sports_item_list">
    <div class="header">
      <div>{{itemDetail.title}}</div>
      <div>{{itemDetail.content}}</div>
    </div>
    <div class="body">
      <ItemList :itemSubList="itemSubList" v-if="itemSubList.length"/>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";
</style>

<script>
import { Empty } from "vant";
import ItemList from './List/Index'
export default {
  components: {
    Empty,
    ItemList
  },
  props: ["item_id"],
  data() {
    return {
      itemDetail: {},
      itemSubList: [],
    };
  },
  methods: {
    init: function () {
      this.$api.sports.getItemSubs({ itemid: this.item_id }).then((res) => {
        let { title, content, list } = res.data;
        this.itemDetail = { title, content };
        this.itemSubList = list;

      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
